/**
 * Select — native <select> styled to match Input. We use the native control
 * rather than a hand-rolled combobox because:
 *   - It's accessible out of the box
 *   - Mobile gets the OS picker
 *   - Country lists with hundreds of options stay fast
 *
 * For richer pickers (search, multi-select), build a separate Combobox primitive.
 */

import { forwardRef } from 'react'
import { HiOutlineChevronDown } from 'react-icons/hi2'

const SIZES = {
  sm: 'h-8  text-xs',
  md: 'h-10 text-sm',
  lg: 'h-12 text-base',
}

const TONES = {
  default: 'bg-surface text-ink-primary border border-border hover:border-border-strong focus:border-brand focus:ring-brand/30',
  glass:   'bg-white/85 text-ink-primary border border-white/60 backdrop-blur-sm focus:border-brand focus:ring-brand/30 shadow-token-sm',
}

const Select = forwardRef(function Select(
  {
    invalid = false,
    size = 'md',
    tone = 'default',
    className = '',
    children,
    ...rest
  },
  ref
) {
  const sizeCls = SIZES[size] || SIZES.md
  const toneCls = TONES[tone] || TONES.default
  const errorCls = invalid ? 'border-danger focus:border-danger focus:ring-danger/30' : ''
  return (
    <div className="relative">
      <select
        ref={ref}
        className={`
          w-full appearance-none rounded-lg ps-3 pe-9 transition-colors
          focus:outline-none focus:ring-2
          ${sizeCls} ${toneCls} ${errorCls} ${className}
        `}
        aria-invalid={invalid || undefined}
        {...rest}
      >
        {children}
      </select>
      <HiOutlineChevronDown
        className="absolute end-3 top-1/2 -translate-y-1/2 w-4 h-4 text-ink-muted pointer-events-none"
        aria-hidden="true"
      />
    </div>
  )
})

export default Select
